import { defineComponent as _defineComponent } from 'vue'
import { Banner } from '@/components/banners/bannerStore'
import { useAppInsights } from '@/common/useAppInsights'


export default /*#__PURE__*/_defineComponent({
  __name: 'banner',
  props: {
    content: null
  },
  setup(__props: any) {



const appInsights = useAppInsights()

const actionClicked = () => {
  appInsights?.trackEvent({ name: 'Sept19BannerSignUp' })

  const signUpLink =
    'https://zoom.us/webinar/register/WN_s3hisyA4Q8COo-7FfSVvfA?utm_campaign=Sept%2019%20Quarterly%20Event&utm_source=app&utm_medium=banner&utm_content=sept-19-2024#/registration'
  window.open(signUpLink, '_blank', 'noreferrer')
}

return { __sfc: true,appInsights, actionClicked }
}

})